    <div class="global-loader-backdrop">
      <div class="global-loader-spinner"></div>
    </div>